export const formattedGivenStringArray = (givenData: any[]): (string | '')[] => {
  return (
    givenData?.map((item) => {
      if (item && typeof item.input === 'string' && Array.isArray(item.rows)) {
        return `input: ${item.input}\nrows:\n${item.rows
          .map((row: any) => {
            if (typeof row === 'object' && row !== null) {
              return `  - {${Object.entries(row)
                .map(([key, value]) => `${key}: "${value}"`)
                .join(', ')}}`;
            }
            return '';
          })
          .join('\n')}`;
      }
      return '';
    }) || []
  );
};

export const formattedExpectStringArray = (expectData: any): string => {
  return `rows:\n${
    Array.isArray(expectData?.rows)
      ? expectData.rows
          .map((row: any) => {
            if (typeof row === 'object' && row !== null) {
              return `  - {${Object.entries(row)
                .map(([key, value]) => `${key}: "${value}"`)
                .join(', ')}}`;
            }
            return '';
          })
          .join('\n')
      : ''
  }`;
};
